export default {
  username: /^[a-zA-Z0-9]+$/u,
  email: /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i, //TODO: ver regex para tenerlo en cuenta para el paso a rsuite
  password: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/,
  number: /^\d+$/u,
  alphaNumeric: /^\w*$/,
  noEmpty: /(?!^$)([^\s])/,
  numberLengthToThirteen: /^\d{1,13}$/,
};
